export const SELECT = 'SELECT_DAILY_WET';
export const SET_AMOUNTS = 'SET_AMOUNTS_DAILY_WET';
export const DEFAULT = 'DEFAULT_DAILY_WET';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_DAILY_WET';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_DAILY_WET';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_DAILY_WET';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
